// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__xvUgB","title":"ClientReferral_title__xs5G6","itemText":"ClientReferral_itemText__4qhXX"};